
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MeasurementSpecification, MeasurementValueType, MediaItem, TeMeasurement } from '../../backend/backendapi';
import CenterOnParent from '../../util/CenterOnParent';
import { getValue } from '../util';
import MeasurementSpecificationsTemplateBadges from '../measurementSpecificationTemplates/MeasurementSpecificationsTemplateBadges';
import { formatDateTime, formatDateTimeForInput, parseDateTimeFromInput } from '../../../util';
import TeMeasurementRowSeparateTesterEditModal from './TeMeasurementRowSeparateTesterEditModal.vue';

export type Attachment = {
  mediaId: string;
  media: MediaItem | null,
}

@Component({
  components: {
    TeMeasurementRowSeparateTesterEditModal,
    CenterOnParent,
    MeasurementSpecificationsTemplateBadges,
  },
})
export default class TestEquipmentMeasurements extends Vue {
  @Prop({ required: true })
  readonly specification!: MeasurementSpecification;
  @Prop({ required: true })
  readonly measurement!: TeMeasurement;
  @Prop({ required: true })
  readonly attachments!: Attachment[];

  getValue = getValue; //required to be used in template, vue2 shortcoming
  formatDateTime = formatDateTime; //required to be used in template, vue2 shortcoming
  MeasurementValueType = MeasurementValueType; //required to be used in template, vue2 shortcoming

  enabledTesterAndDate = false;

  get isFloat(): boolean {
    return this.specification.type === MeasurementValueType.Float;
  }

  get isString(): boolean {
    return this.specification.type === MeasurementValueType.String;
  }

  get statusColor(): string {
    if (this.isFloat) {
      let value = this.measurement.value ? parseFloat(this.measurement.value) : undefined;
      let lowerBound = parseFloat(this.specification.lowerBound);
      let upperBound = parseFloat(this.specification.upperBound);
      if (value !== undefined
          && lowerBound <= value
          && value <= upperBound) {
        return '#33ff66';
      }
    } else if (this.isString) {
      if (this.measurement.value !== undefined
          && this.specification.nominalValue === this.measurement.value) {
        return '#33ff66';
      }
    }

    //out of bounds
    if (this.specification.optional) {
      return '#3366ff';
    } else {
      return '#ff3300';
    }
  }

  mounted(): void {
    this.onChanged();
  }

  enableTesterAndDate(): void {
    if (!this.specification.allowSeparateTester) {
      return;
    }

    this.enabledTesterAndDate = true;
    if (!this.measurement.testerName) {
      this.$set(this.measurement, 'testerName', null);
    }
    if (!this.measurement.testDate) {
      this.$set(this.measurement, 'testDate', parseDateTimeFromInput(formatDateTimeForInput(new Date()))); //strip sub minute precision
    }

    (this.$refs.separateTesterEditModal as TeMeasurementRowSeparateTesterEditModal).open(this.measurement);
  }

  @Watch('specification')
  @Watch('measurement')
  onChanged(): void {
    this.enabledTesterAndDate = (this.specification.allowSeparateTester ?? false)
        && (!!this.measurement.testerName || !!this.measurement.testDate);
  }
}
